module.exports = __webpack_public_path__ + "img/join.53aa841b.jpg";